export const SUMMARY_FIELDS = [
  {
    key: "AR_Code",
    label: "รหัสลูกค้า",
    w: "8%",
    alignHeader: "center",
    align: "center",
    numeric: false,
    sortable: true,
  },
  {
    key: "AR_Name",
    label: "ชื่อลูกค้า",
    w: "15%",
    alignHeader: "center",
    align: "left",
    numeric: false,
    sortable: true,
  },

    {
    key: "Item_Name",
    label: "สินค้าล่าสุดที่ซื้อ",
    w: "8%",
    alignHeader: "center",
    align: "center",
    numeric: false,
    sortable: true,
  },
    {
    key: "lastPurchaseDate",
    label: "วันที่ซื้อครั้งล่าสุด",
    w: "8%",
    alignHeader: "center",
    align: "center",
    numeric: false,
    sortable: true,
  },
  {
    key: "daysSinceLast",
    label: "วันที่ผ่านมา (วัน)",
    w: "8%",
    alignHeader: "end",
    align: "end",
    numeric: false,
    sortable: true,
  },
  {
    key: "purchaseCount",
    label: "จำนวนคำสั่งซื้อ (ครั้ง)",
    w: "8%",
    alignHeader: "end",
    align: "end",
    numeric: false,
    sortable: true,
  },
  {
    key: "totalSpent",
    label: "มูลค่าซื้อรวม (฿)",
    w: "8%",
    alignHeader: "end",
    align: "end",
    numeric: true,
    sortable: true,
  },
];

export const DETAIL_FIELDS = [
  {
    key: "Doc_Date",
    label: "วันที่",
    w: "12%",
    alignHeader: "center",
    align: "center",
    numeric: false,
  },
  {
    key: "Doc_No",
    label: "เลขที่เอกสาร",
    w: "12%",
    alignHeader: "center",
    align: "center",
    numeric: false,
  },
  {
    key: "Item_Code",
    label: "รหัสสินค้า",
    w: "17%",
    alignHeader: "center",
    align: "center",
    numeric: false,
  },
  {
    key: "Item_Name",
    label: "ชื่อสินค้า",
    w: "50%",
    alignHeader: "center",
    align: "center",
    numeric: false,
  },
  {
    key: "Item_Price_Unit",
    label: "ราคา/หน่วย",
    w: "12%",
    alignHeader: "center",
    align: "end",
    numeric: true,
  },
  {
    key: "Item_Qty",
    label: "จำนวน",
    w: "8%",
    alignHeader: "center",
    align: "end",
    numeric: true,
  },
  {
    key: "NetTotal",
    label: "รวมเงิน",
    w: "14%",
    alignHeader: "center",
    align: "end",
    numeric: true,
  },
  {
    key: "Item_Discount",
    label: "ส่วนลด",
    w: "8%",
    alignHeader: "center",
    align: "end",
    numeric: true,
  },
  {
    key: "Item_Total",
    label: "ราคารวม",
    w: "8%",
    alignHeader: "center",
    align: "end",
    numeric: true,
  },
];
